/**
 * WhiskYves Header Menu - Mobile Toggle
 */
document.addEventListener('DOMContentLoaded', function() {
	const mobileToggle = document.querySelector('.wv-header__mobile-toggle');
	const nav = document.querySelector('.wv-header__nav--left');
	
	if (!mobileToggle || !nav) return;
	
	mobileToggle.addEventListener('click', function() {
		const isExpanded = this.getAttribute('aria-expanded') === 'true';
		this.setAttribute('aria-expanded', !isExpanded);
		nav.classList.toggle('is-open');
		document.body.classList.toggle('menu-open');
	});
	
	// Close menu when clicking outside
	document.addEventListener('click', function(e) {
		if (!nav.contains(e.target) && !mobileToggle.contains(e.target) && nav.classList.contains('is-open')) {
			nav.classList.remove('is-open');
			mobileToggle.setAttribute('aria-expanded', 'false');
			document.body.classList.remove('menu-open');
		}
	});
});

